import { ComponentProps } from 'react';
import Steps from 'antd/es/steps';
import clsx from 'clsx';

interface OpStepsProps extends ComponentProps<typeof Steps> {
  testId?: string;
}

/**
 * OpSteps is a wrapper around Ant Design's Steps component.
 * It displays progress through a sequence of logical steps in a process.
 * 
 * Use this component to guide users through multi-step processes like forms, wizards, or workflows.
 * Clearly shows current position and completion status.
 * 
 * @example
 * <OpSteps current={1}>
 *   <OpSteps.Step title="Step 1" />
 *   <OpSteps.Step title="Step 2" />
 *   <OpSteps.Step title="Step 3" />
 * </OpSteps>
 * 
 */
export const OpSteps = ({
  children,
  className,
  testId,
  ...stepsProps
}: OpStepsProps) => (
  <Steps
    className={clsx('op-steps', className)}
    data-testid={testId}
    {...stepsProps}
  />
);
